<div class="row">
  <div class="col-md-6">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Application {{Title}}</h4>
        <div class="form-group">
          <label for="ApplicationID">Application ID *</label>
          <div class="input-group">
            <input type="text" class="required form-control" required id="ApplicationID" [(ngModel)]="Doc.ApplicationID"
              #ApplicationID="ngModel" aria-label="Application ID" placeholder="" [readonly]="!IsNew" />
          </div>
          <div [hidden]="ApplicationID.valid || ApplicationID.pristine" class="alert alert-danger">
            Application ID is required
          </div>
        </div>
        <div class="form-group">
          <label for="AuthCode">Auth Code(Base64) *</label>
          <input type="text" class="required form-control" #AuthCode="ngModel" id="AuthCode" placeholder="" required
            [(ngModel)]="Doc.AuthCode" />

          <div [hidden]="AuthCode.valid || AuthCode.pristine" class="alert alert-danger">
            Auth Code is required
          </div>
        </div>
        <div class="form-group">
          <label for="IP">IP(CIDR)</label>
          <div class="input-group">
            <input type="text" class="required form-control" required id="IP" [(ngModel)]="Doc.IP"
              #IP="ngModel" aria-label="IP" placeholder=""/>
          </div>
        </div>
        <div class="form-group">
          <label for="GrantType">GrantType</label>
          <ng-select [searchable]="false" [items]="Doc.ddlGrantType" id="GrantType" bindValue="value" bindLabel="text"
            [clearable]="false" [(ngModel)]="Doc.GrantType">
          </ng-select>
        </div>
        
        <div class="form-group">
          <label for="ReturnUrl">ReturnUrl</label>
          <div class="input-group">
            <input type="text" class="required form-control" required id="ReturnUrl" [(ngModel)]="Doc.ReturnUrl"
              #ReturnUrl="ngModel" aria-label="ReturnUrl" placeholder=""/>
          </div>
        </div>
        <div class="form-group">
          <label for="ErrorReturnUrl">ErrorReturnUrl</label>
          <div class="input-group">
            <input type="text" class="required form-control" required id="ErrorReturnUrl" [(ngModel)]="Doc.ErrorReturnUrl"
              #ErrorReturnUrl="ngModel" aria-label="ErrorReturnUrl" placeholder=""/>
          </div>
        </div>
        <div class="form-group">
          <label for="TokenAPI">TokenAPI</label>
          <div class="input-group">
            <input type="text" class="required form-control" required id="TokenAPI" [(ngModel)]="Doc.TokenAPI"
              #TokenAPI="ngModel" aria-label="TokenAPI" placeholder=""/>
          </div>
        </div>
        <div class="form-group">
          <label for="PermissionAPI">PermissionAPI</label>
          <div class="input-group">
            <input type="text" class="required form-control" required id="PermissionAPI" [(ngModel)]="Doc.PermissionAPI"
              #PermissionAPI="ngModel" aria-label="PermissionAPI" placeholder=""/>
          </div>
        </div>
        <div class="form-group">
          <label for="Enabled">IsEnabled</label>
          <ng-select [searchable]="false" [items]="Doc.ddlIsEnabled" id="IsEnabled" bindValue="value" bindLabel="text"
            [clearable]="false" [(ngModel)]="Doc.SelectEnabled">
          </ng-select>
        </div>
        <p>(*) Mandatory</p>
      </div>
      <div class="border-top">
        <div class="card-body">
          <button (click)="Cancel()" class="btn btn-outline-secondary" role="button">Cancel</button>
          <button (click)="Submit()" class="btn btn-success ml-1" role="button" [disabled]="isValid()">Submit</button>
        </div>
      </div>
    </div>
    <div>
    </div>
  </div>
  <footer class="footer text-center"></footer>
</div>
